const highlightPreTag = "####";
const highlightPostTag = "&&&&";

export const dehighlight = highlightedText =>
  (highlightedText || "")
    .replace(new RegExp(highlightPreTag, "gi"), "")
    .replace(new RegExp(highlightPostTag, "gi"), "");
